import CommonLayout from '../../layouts/commonLayout/CommonLayout'

function Account() {
  return (
    <CommonLayout>
      <h1>Account Page</h1>
    </CommonLayout>
  )
}

export default Account
